import React, { useState } from "react";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationDE from "../../locale/de/translation.json";
import translationEN from "../../locale/en/translation.json";
import { IKonfigurationStPos } from "../../Models/IKonfigurationStPos";
import {
  Button,
  createTableColumn,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Text,
} from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import {
  ArrowDownloadRegular,
  DocumentTextRegular,
  ImageRegular,
  MoreVerticalFilled,
} from "@fluentui/react-icons";

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

// initialize i18next with catalog and language to use
i18n.use(LanguageDetector).init({
  resources,
});

export function ConfiguratorStResultColumns(preiseSichtbar: boolean) {
  const windowSize = useWindowSize();
  const [clickedArtikel, setClickedArtikel] = useState<any>(undefined);
  const [przArtikelId, setPrzArtikelId] = useState<string | undefined>(
    undefined,
  );
  const [kvmArtikelId, setKvmArtikelId] = useState<string | undefined>(
    undefined,
  );

  const targetButton = React.useRef<HTMLDivElement>(null);

  const columns = [
    // ------------Artikel------------
    createTableColumn<IKonfigurationStPos>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("artikelId")}</Text>;
      },
      renderCell: (item) => {
        return (
          <>
            <Text>
              {item.artikelId}
              {item.artikelId == i18n.t<string>("gesamtPreis") && (
                <Text style={{ color: "#ff6600" }}>*</Text>
              )}
            </Text>
          </>
        );
      },
    }),
    // ------------Actions------------
    createTableColumn<IKonfigurationStPos>({
      columnId: "actionId",
      renderCell: (item) => {
        const menuItems = [];

        if (item.hasSachwerte) {
          menuItems.push({
            key: "productDetails",
            iconProps: { iconName: "KnowledgeArticle" },
            icon: <DocumentTextRegular />,
            text: i18n.t<string>("productDetails"),
            onClick: () => {
              setClickedArtikel(item);
            },
          });
        }

        if (item.hasPrzDocument) {
          menuItems.push({
            disabled: false,
            key: "showPrz",
            iconProps: { iconName: "OpenFile" },
            icon: <ImageRegular />,
            text: i18n.t<string>("showPRZ"),
            onClick: () => {
              setPrzArtikelId(item.artikelId);
            },
          });
        }

        if (item.hasKvmDocument) {
          menuItems.push({
            disabled: false,
            key: "downloadKvm",
            iconProps: { iconName: "GiftboxOpen" },
            icon: <ArrowDownloadRegular />,
            text: i18n.t<string>("downloadKvm"),
            onClick: () => {
              setKvmArtikelId(item.artikelId);
            },
          });
        }

        if (menuItems.length > 0) {
          return (
            <div
              className="lueb-centerVertical"
              ref={item.position == 1 ? targetButton : undefined}
            >
              <Menu>
                <MenuTrigger>
                  <Button
                    appearance="transparent"
                    icon={<MoreVerticalFilled color="#ff6600" />}
                  />
                </MenuTrigger>
                <MenuPopover>
                  <MenuList>
                    {menuItems.map((menuItem) => {
                      return (
                        <MenuItem
                          icon={menuItem.icon}
                          onClick={() => {
                            menuItem.onClick();
                          }}
                        >
                          {menuItem.text}
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </MenuPopover>
              </Menu>
            </div>
          );
        } else {
          return <div></div>;
        }
      },
    }),
    // ------------ Sachgruppe -------------
    createTableColumn<IKonfigurationStPos>({
      columnId: "sachgruppeId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("sachgruppe")}</Text>;
      },
      renderCell: (item) => {
        if (item.artikel) {
          return (
            <Text>
              {i18n.language.includes("de")
                ? item.artikel?.sachgruppe?.benennungDE
                : item.artikel?.sachgruppe?.benennungEN}
            </Text>
          );
        }
      },
    }),
    // ------------ BENNENUNG -------------
    createTableColumn<IKonfigurationStPos>({
      columnId: "benennungM1",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        let benennung = "";
        if (item.hasOwnProperty("artikel")) {
          if (
            item.artikel &&
            item.artikel.benennungDE &&
            item.artikel.benennungEN
          ) {
            benennung = i18n.language.includes("de")
              ? item.artikel.benennungDE
              : item.artikel.benennungEN;
          }
        }
        return (
          <div className="lueb-centerVertical">
            <Text>{benennung}</Text>
          </div>
        );
      },
    }),
    // ------------ Gewicht -------------
    createTableColumn<IKonfigurationStPos>({
      columnId: "gewichtId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("gewicht")}</Text>;
      },
      renderCell: (item) => {
        if (item.artikel && item.artikel.gewicht) {
          return <Text>{item.artikel.gewicht}</Text>;
        } else return <div></div>;
      },
    }),

    /* // ------------ Beistellung -------------
    createTableColumn<IKonfigurationStPos>({
      columnId: "beistellungId",

      renderCell: (item) => {
        return <Checkbox disabled checked={item.beistellung} />;
      },
    }), */
  ];
  if (preiseSichtbar) {
    columns.push(
      // ------------ Preis -------------
      createTableColumn<IKonfigurationStPos>({
        columnId: "preisId",
        renderHeaderCell: () => {
          return (
            <Text>
              {i18n.t<string>("preis")}
              <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
            </Text>
          );
        },
        renderCell: (item) => {
          if (
            item.artikel?.netto &&
            item.artikel?.netto > 0 &&
            !item.beistellung
          ) {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.artikel?.netto
                    ? item.artikel?.netto.toLocaleString(
                        i18n.language.includes("de") ? "de-DE" : "en-EN",
                        { minimumFractionDigits: 2 },
                      ) + " €"
                    : ""}
                </Text>
              </div>
            );
          } else {
            return <div></div>;
          }
        },
      }),
    );
  }

  return {
    clickedArtikel: clickedArtikel,
    przArtikelId: przArtikelId,
    kvmArtikelId: kvmArtikelId,
    resetPrzArtikelId: () => setPrzArtikelId(undefined),
    resetKvmArtikelId: () => setKvmArtikelId(undefined),
    resetClickedArtikel: () => setClickedArtikel(undefined),
    columns: columns,
  };
}
